// Centralized js-cookie instance that applies secure attributes to EVERY cookie.
//
// This module is aliased to the bare "js-cookie" import via next.config.js
// (webpack `resolve.alias`), so every existing `import Cookies from "js-cookie"`
// call site across the codebase transparently inherits these defaults:
//   - Secure        -> cookie only sent over HTTPS
//   - SameSite=Strict -> cookie not sent on cross-site requests (CSRF hardening)
//   - path=/        -> consistent path so existing get/remove keep working
//
// Per-call attributes (e.g. `{ expires: 365 }`) still work and take precedence,
// they are merged on top of these defaults by js-cookie's `withAttributes`.
//
// NOTE: `HttpOnly` cannot be set from client-side JavaScript (it is a server-only
// Set-Cookie attribute). Cookies created here are written by the browser, so they
// cannot be HttpOnly. For truly sensitive values (e.g. the auth token) consider
// setting them server-side via a Next.js Route Handler / Server Action.
//
// `js-cookie-real` is a second webpack alias that resolves to the real js-cookie
// package file, which avoids an aliasing loop back into this wrapper.
import Cookies from "js-cookie-real";

const secureCookies = Cookies.withAttributes({
  path: "/",
  secure: true,
  sameSite: "strict",
});

export default secureCookies;
